import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';
import { Loader2 } from 'lucide-react';

const Index = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return; // Wait until auth is resolved

    if (!user) {
      navigate('/auth', { replace: true });
      return;
    }

    (async () => {
      // Check rider first
      const { data: rider } = await supabase.from('delivery_riders').select('id').eq('user_id', user.id).maybeSingle();
      if (rider) { navigate('/rider', { replace: true }); return; }

      // Check branch manager
      const { data: bm } = await supabase.from('branch_managers').select('id').eq('user_id', user.id).eq('is_active', true).maybeSingle();
      if (bm) { navigate('/branch-manager', { replace: true }); return; }

      // Role-based redirect: management → /dashboard, cashier/staff → /cashier-home
      const { data } = await supabase.from('user_roles').select('role').eq('user_id', user.id);
      const roles = (data || []).map(r => r.role);
      const managementRoles = ['super_admin', 'owner', 'admin', 'manager'];
      const isManagement = roles.some(r => managementRoles.includes(r));
      navigate(isManagement ? '/dashboard' : '/cashier-home', { replace: true });
    })();
  }, [user, loading, navigate]);

  // Always show a loading spinner — never render <Auth /> here
  // The auth page is at /auth route, not embedded here
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};

export default Index;
